import axios from 'axios';

const base64 = require('base-64');
const store = require('store');

export function SetCookie(name, value, days) {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
};

export function GetCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(";").shift();
	return null;
};

export function GetToken() {
	let token = {
		id: null,
		access_token: null,
		refresh_token: null,
	}

	let data = store.get('token')
	if (typeof data !== 'undefined') {
		let d = JSON.parse(base64.decode(data))
		for (var k in d) {
			if (d.hasOwnProperty(k)) {
				token[k] = d[k];
			}
		}
	}

	return token
}

export function GetUser() {
	let user = {
		id: null,
		name: null,
		nip: null,
		email: null,
		phone: null,
		virtual_account: null,
		is_affiliate: false,
		is_email_verified: false,
		is_phone_verified: false,
		country_code: null,
		province: null,
		city: null,
		role: {
			id: 1,
			name: 'Guest',
		},
		created_at: null,
		updated_at: null,
	}

	let data = store.get('user')
	if (typeof data !== 'undefined') {
		let d = JSON.parse(base64.decode(data))
		for (var k in d) {
			if (d.hasOwnProperty(k)) {
				user[k] = d[k];
			}
		}
	}

	return user
}

export function GetRole() {
	let role = GetUser().role
	if (typeof role.id !== 'undefined') {
		return role
	} else {
		return {
			id: 1,
			name: 'Guest',
		}
	}
};

export function SetSession(token) {
	store.set('token', token)
	let t = JSON.parse(base64.decode(token))
	if (typeof t !== 'undefined' && typeof t.access_token !== 'undefined') {
		axios.get('/api/v1/me', { headers: { Authorization: 'Bearer ' + t.access_token } }).then(res => {
			store.set('user', base64.encode(JSON.stringify(res.data)))
		});
	}
}

export function RefreshSession() {
	axios.get('/auth', { headers: { Authorization: 'Bearer ' + base64.encode('refresh_token:' + GetToken().refresh_token) } }).then(res => {
		SetSession(res.data.token)
	}).catch(err => {
		ClearSession()
	})
}

export function ClearSession() {
	store.remove('token')
	store.remove('user')
}

export function GuestLogin() {
	return axios.get('/auth', { headers: { Authorization: 'Bearer ' + base64.encode('it.hsipernik@gmail.com:123456') } })
}

export function Login(username, password) {
	return axios.get('/auth', { headers: { Authorization: 'Bearer ' + base64.encode(username + ':' + password) } })
}

export function ResetPassword(body) {
	return axios.post('/api/v1/reset_password', body, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function Verify(body) {
	return axios.post('/api/v1/verify', body, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function SetToken(encoded_token) {
	store.set('token', encoded_token)

	let token = {
		id: null,
		access_token: null,
		refresh_token: null,
	}

	let d = JSON.parse(base64.decode(encoded_token))
	for (var k in d) {
		if (d.hasOwnProperty(k)) {
			token[k] = d[k];
		}
	}

	return token
}

export function Me(access_token) {
	return axios.get('/api/v1/me', { headers: { Authorization: 'Bearer ' + access_token } })
}

export function SetUser(user) {
	store.set('user', base64.encode(JSON.stringify(user)))
}

export function UpdateMe(data) {
	return axios.patch('/api/v1/me', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function UpdateToken() {
	return axios.get('/auth', { headers: { Authorization: 'Bearer ' + base64.encode('refresh_token:' + GetToken().refresh_token) } })
}

export function GetReferral() {
	return GetCookie('referral')
}

export function SetReferral(referral_code) {
	if (!GetReferral()) {
		SetCookie('referral', referral_code, 30)
	}
}
